import Button from '../../simple/Button';
import ModalClosable from '../ModalClosable';
import { Row } from 'antd';
import './CalendarReportModal.scss';
import moment from 'moment-timezone';

export default function CalendarReportModal(props) {
    return (
        <ModalClosable
            width={500}
            wrapClassName='CalendarReportModal'
            { ...props }
        >
            <h3>Calendario de cliente</h3>
            <p>
                Se generará un reporte del calendario del cliente a partir del mes actual hasta el fin del plan de estudios programado para los grupos.
            </p>
            <Row justify='end' gutter={10}>
                <Button onClick={() => {
                    const date = moment().startOf('month');
                    const start = date;
                    const end = date.clone().add(1, 'year').add(1, 'month');
                    const rangeData = {
                        startdate: start ? start.valueOf() : null,
                        enddate: end ? end.valueOf() : null
                    };
                    props.downloadCalendarReport(props.client.id, rangeData);
                }}>Descargar</Button>
            </Row>
        </ModalClosable>
    );
}